// extracted by mini-css-extract-plugin
export default {"root":"UIErrorBoundary_root__2i2dT"};